import script from "./Ebitda.vue?vue&type=script&setup=true&lang=js"
export * from "./Ebitda.vue?vue&type=script&setup=true&lang=js"

import "./Ebitda.vue?vue&type=style&index=0&id=1126eac4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1126eac4"]])

export default __exports__